import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormArray, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { Customer } from 'src/app/Model/Shipping/customer';
import { CollectPayReq } from 'src/app/Model/Shipping/collect-pay-req';
import { UpiPaymentDetails } from 'src/app/Model/Shipping/upi-payment-details';
import { UpiPaymentDetailDto } from 'src/app/Model/Shipping/upi-payment-detail-dto';
import { UpiCodeResponse } from 'src/app/Model/Shipping/upi-code-response';
import { CommonPayments } from 'src/app/Model/Shipping/common-payments';
import { UpiPaymentDto } from 'src/app/Model/Shipping/upi-payment-dto';
import { CollectionDto } from 'src/app/Model/Shipping/collection-dto';
import { PaytmRequestDto } from 'src/app/Model/Shipping/PaytmRequestDto';
import { UpiBankSetup } from 'src/app/Model/Shipping/upi-bank-setup';
import { TransactionDetails } from 'src/app/Model/Shipping/transaction-details';
import { WalletTransaction } from 'src/app/Model/Shipping/wallet-transaction';
import { WalletOffers } from 'src/app/Model/Shipping/wallet-offers';
import { WalletOfferRequestDto } from 'src/app/Model/Shipping/wallet-offer-request-dto';
import { GatewayPaymentSetup } from 'src/app/Model/Shipping/gateway-payment-setup';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { Subscription } from 'rxjs';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { BankPayment } from 'src/app/Model/Shipping/bank-payment';
import { BankPaymentDetailDto } from 'src/app/Model/Shipping/bank-payment-detail-dto';
import { CardPayment } from 'src/app/Model/Shipping/card-payment';
import { CardPaymentDetailDto } from 'src/app/Model/Shipping/card-payment-detail-dto';
import { UpiPayment } from 'src/app/Model/Shipping/upi-payment';
import { PaytmPaymentDto } from 'src/app/Model/Shipping/paytm-payment-dto';
import { CouponPayment } from 'src/app/Model/Shipping/coupon-payment';
import { CouponPaymentDetail } from 'src/app/Model/Shipping/coupon-payment-detail';
import { CashPayment } from 'src/app/Model/Shipping/cash-payment';
import { WalletPayment } from 'src/app/Model/Shipping/wallet-payment';
import { SwipePayment } from 'src/app/Model/Shipping/swipe-payment';
import { GatewayPayment } from 'src/app/Model/Shipping/gateway-payment';
import { PaytmResponse } from 'src/app/Model/Shipping/paytm-response';
import { CCAvenueDataFormat } from 'src/app/Model/Shipping/CCAvenueDataFormat';
import { WhatsAppMessageDto } from 'src/app/Model/Shipping/whats-app-message-dto';
import { CreateOrderCustomerComponent } from '../create-order-customer/create-order-customer.component';
import { AppConfigService } from 'src/app/Service/Configuration/app-config.service';
import { SessionStorageService } from 'src/app/Model/Common/SessionStorageService';


@Component({
  selector: 'app-multiple-transaction',
  templateUrl: './multiple-transaction.component.html',
  styleUrls: ['./multiple-transaction.component.css'],
  // encapsulation: ViewEncapsulation.None
})

export class MultipleTransactionComponent implements OnInit {

  tabs = [
    { title: 'CASH' },
    { title: 'UPI' },
    { title: 'SWIPE' },
    { title: 'COUPON' },
    { title: 'GATEWAY' },
    { title: 'BANK' },
    { title: 'WALLET' },
    // { title: 'PAYTM' },
    // { title: 'CARD' },
  ];
  upiCustomerSelected: Customer = new Customer();
  UpiCustomerName: string = '';
  UpiCustomerMobileNo: string = '';
  UpiCustomerCode: string = '';

  paytmCustomerSelected: Customer = new Customer();
  PaytmCustomerName: string = '';
  PaytmCustomerMobileNo: string = '';
  PaytmCustomerCode: string;

  selectedTitle: string;
  selectedIndex: number;
  title: string;
  total_bill_amt: number = 0;
  balance: number = 0;
  denomination: number[] = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1];
  amountToPay: number = 0;
  intPart: number;
  intCountDen: number;
  amt: number[] = [];
  sortedAmt: number[] = [];
  Amount: number = 0;
  total_amt_cash: number = 0;
  total_amt_upi: number = 0;
  total_amt_paytm: number = 0;
  total_amt_bank: number = 0;
  total_amt_coupon: number = 0;
  total_amt_card: number = 0;
  total_amt_wallet: number = 0;
  total_amt_gateway: number = 0;
  total_amt_swipe: number = 0;
  total_amt_byAllTypes: number = 0;
  upi_amount_to_pay: number = 0;
  paytm_amount_to_pay: number = 0;
  bank_amount_to_pay: number = 0;
  coupon_amount_to_pay: number = 0;
  PayeeVA: string = '';
  generatedQRCode: string = "";
  showQrCodeLabel: boolean = true;
  showQrCode: boolean = false;
  upiCodeResponse: UpiCodeResponse;
  merchantTnxId: string;
  errorCorrectionLevel: string;
  paymentType: string = "b2c";
  transactionStatus: string;
  PaytmMessageDesc: string = '';
  couponAmount: number[] = [];

  collectPayReq: CollectPayReq;
  upiPaymentDetails: UpiPaymentDetails;
  upiPaymentDetailDto: UpiPaymentDetailDto[] = [];
  upiPaymentDetail: UpiPaymentDetailDto;
  upiPaymentDto: UpiPaymentDto = new UpiPaymentDto();
  collectionDto: CollectionDto = new CollectionDto();
  paytmRequestDto: PaytmRequestDto = new PaytmRequestDto();
  transactionDetailPaymentsDto: CommonPayments = new CommonPayments();
  locationlocal: any;
  companyCode: number;
  bankBankSetup: any;
  cardBankSetup: any;
  upiBankSetup: UpiBankSetup[] = [];

  upiAmount: number = 0;
  paytmAmount: number = 0;

  //data to be returned to cash register component
  transactionDtls: TransactionDetails = new TransactionDetails();
  payerVA: any = "";
  originalBankRRN: any = "";
  merchantTranId: string = "";
  transAmt: any = "";
  txnCompletionDate: any = "";
  status: boolean = false;
  bankBranch: string;
  bankName: string;
  chequeDate: string;
  chequeNoUTRNo: string;
  ifscCode: string;
  createCollectionForm: UntypedFormGroup;
  totalCouponAmount: number;

  //For wallet
  walletTransaction: WalletTransaction[] = [];
  walletOfferRequestDto: WalletOfferRequestDto = new WalletOfferRequestDto();
  offerList: WalletOffers[] = [];
  walletBalance: number = 0;
  useableWalletBalance: number = 0;

  //New variables
  isUpiSelectedCustomer: boolean = false;
  isPaytmSelectedCustomer: boolean = false;
  cardTypes: string[] = ['Credit', 'Debit'];
  upiPaymentModeList: string[] = [];
  upiPaymentMode: string;

  // recent add
  refundAmt: number = 0;
  isEditWallet: boolean = false;

  //swipe
  swipeTransId: string;
  paytmPaymentStatus: string;
  paytmPaymentResponseCode: number;
  edcStatus: string = '';

  //gateway
  gatewayTransId: string;
  gatewayPaymentResponseCode: number;
  uploadedFile: File;
  pgStatus: string = '';
  gatewayPaymentSetup: GatewayPaymentSetup = new GatewayPaymentSetup();

  //paytm
  generatedQRCodePaytm: string = "";
  showQrCodeLabelPaytm: boolean = true;
  showQrCodePaytm: boolean = false;
  paytmCodeResponse: UpiCodeResponse;
  merchantTnxIdPaytm: string;
  statusPaytm: boolean = false;
  enableFetchSwipeBtn: boolean = true;

  errorLog: ErrorLog = new ErrorLog();

  //Subscriptions
  private qrCodeSubscription: Subscription;
  private sendSmsSubscription: Subscription;
  private collectPaySubscription: Subscription;
  private fetchPaymentSubscription: Subscription;
  private getCouponAmountSubscription: Subscription;
  private getBankSetupSubscription: Subscription;
  private getCardSetupSubscription: Subscription;
  private getUpiSetupSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  private onViewWalletSubscription: Subscription;
  private getwalletOfferSubscription: Subscription;
  private sendRequestEdcSubscription: Subscription;
  private checkPayTmPaymentStatusSubscription: Subscription;
  private savePaytmResposeSubscription: Subscription;
  private sendRequestGatewaySubscription: Subscription;
  private onSendWhatsAppSubscription: Subscription;
  private checkGatewayPaymentStatusSubscription: Subscription;
  private paytmQrCodeSubscription: Subscription;
  private paytmCollectPaySubscription: Subscription;
  private paytmFetchPaymentSubscription: Subscription;
  private getGatewaySetupSubscription: Subscription;
  private intervalSubscription: Subscription;

  constructor(

    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<MultipleTransactionComponent>,
    public dialog: MatDialog,
    private toastService: ToastrService,
    private shippingManagerService: ShippingManagerService,
    private apiFactory: APIFactoryEndPoints,
    private constant: Constant,
    public persistenceService: LocalStorageService,
    private appConfig: AppConfigService,
    private sessionStorage: SessionStorageService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any

  ) {
    console.log(this.dialogData)
    this.selectedTitle = this.dialogData.tabBtn;
    this.selectedIndex = this.tabs.findIndex(element => element.title == this.selectedTitle);
    this.locationlocal = this.dialogData.trnsactionDto.locationCode;
    this.companyCode = this.dialogData.trnsactionDto.companyCode;

    this.getCardSetupDetails();
    this.getBankSetupDetails();
    this.getUpiSetupDetails();

    this.total_bill_amt = this.dialogData.amt;
    this.balance = Number(((this.dialogData.amt - this.dialogData.trnsactionDto.amount) * 100) / 100); // changed for saved value

    if (this.dialogData.trnsactionDto.refundAmt > 0) {
      this.refundAmt = this.dialogData.trnsactionDto.refundAmt;
      this.balance -= this.refundAmt;
    }

    this.amountToPay = this.dialogData.amt;
    this.refundAmt = this.dialogData.trnsactionDto.refundAmt;
    this.transactionDetailPaymentsDto = this.dialogData.trnsactionDto;
    if (this.transactionDetailPaymentsDto?.walletPayment?.refNo)
      this.isEditWallet = true;
    else
      this.isEditWallet = false;

    if (this.selectedTitle == 'WALLET') {
      this.getWalletHistory();
    }
  }

  ngOnInit(): void {
    this.createCollection();
    // let amt = 0;
    // if(this.transactionDetailPaymentsDto && this.transactionDetailPaymentsDto.cashPayment.amount){
    //   amt =this.transactionDetailPaymentsDto.cashPayment.amount;
    // }
    this.onCreateDenominations(this.amountToPay);
    // data transfer to parent while back drop or esc click
    // this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.transactionDtls));

    this.setCashPaymentDetails();
    this.setCouponPaymentDetails();
    this.setPaytmPaymentDetails();
    this.setWalletPaymentDetails();
    this.setSwipePaymentDetails();
    this.setGatewayPaymentDetails();

    if (this.refundAmt > 0)
      this.balance -= this.refundAmt;
  }

  onCreateDenominations(amountToPay) {

    // let baseRoundAmount = this.amountToPay | 1.1 - 0
    let baseRoundAmount = amountToPay
    if (baseRoundAmount != amountToPay) {
      baseRoundAmount = baseRoundAmount - 1
      this.amt.push(baseRoundAmount)
    }

    for (let k = 0; k < this.denomination.length; k++) {
      this.intPart = (amountToPay / this.denomination[k]) | 0;
      if (this.intPart * this.denomination[k] >= amountToPay)
        this.intCountDen = this.intPart
      else
        this.intCountDen = this.intPart + 1;
      let amountmaybePaid: number = this.denomination[k] * this.intCountDen
      let found: boolean = false;
      for (let m = 0; m < this.amt.length; m++) {
        if (amountmaybePaid == this.amt[m])
          found = true;
      }
      if (found == false)
        this.amt.push(amountmaybePaid);

      if (this.intCountDen > 1) {
        let fixedAmt: number = (this.intCountDen - 1) * this.denomination[k];
        let minPay: number = amountToPay - fixedAmt;
        for (let l = k + 1; l < this.denomination.length; l++) {
          this.intPart = (minPay / this.denomination[l]) | 0;
          if (this.intPart * this.denomination[l] >= minPay)
            this.intCountDen = this.intPart
          else
            this.intCountDen = this.intPart + 1;

          let amountmaybePaid: number = this.denomination[l] * this.intCountDen
          if (fixedAmt + amountmaybePaid >= amountToPay) {
            found = false;
            for (let m = 0; m < this.amt.length; m++) {
              if (fixedAmt + amountmaybePaid == this.amt[m])
                found = true;
            }
            if (found == false)
              this.amt.push(fixedAmt + amountmaybePaid);
          }
        }
      }
      this.sortedAmt = this.amt.sort();
    }
  }

  ngOnDestroy() {
    if (this.qrCodeSubscription !== undefined) {
      this.qrCodeSubscription.unsubscribe();
    }
    if (this.sendSmsSubscription !== undefined) {
      this.sendSmsSubscription.unsubscribe();
    }
    if (this.collectPaySubscription !== undefined) {
      this.collectPaySubscription.unsubscribe();
    }
    if (this.fetchPaymentSubscription !== undefined) {
      this.fetchPaymentSubscription.unsubscribe();
    }
    if (this.getCouponAmountSubscription !== undefined) {
      this.getCouponAmountSubscription.unsubscribe();
    }
    if (this.getBankSetupSubscription !== undefined) {
      this.getBankSetupSubscription.unsubscribe();
    }
    if (this.getCardSetupSubscription !== undefined) {
      this.getCardSetupSubscription.unsubscribe();
    }
    if (this.getUpiSetupSubscription !== undefined) {
      this.getUpiSetupSubscription.unsubscribe();
    }
    if (this.insertErrorLogSubscription !== undefined) {
      this.insertErrorLogSubscription.unsubscribe();
    }
    if (this.onViewWalletSubscription !== undefined) {
      this.onViewWalletSubscription.unsubscribe();
    }
    if (this.getwalletOfferSubscription !== undefined) {
      this.getwalletOfferSubscription.unsubscribe();
    }
    if (this.sendRequestEdcSubscription !== undefined) {
      this.sendRequestEdcSubscription.unsubscribe();
    }
    if (this.checkPayTmPaymentStatusSubscription !== undefined) {
      this.checkPayTmPaymentStatusSubscription.unsubscribe();
    }
    if (this.savePaytmResposeSubscription !== undefined) {
      this.savePaytmResposeSubscription.unsubscribe();
    }
    if (this.sendRequestGatewaySubscription !== undefined) {
      this.sendRequestGatewaySubscription.unsubscribe();
    }
    if (this.onSendWhatsAppSubscription !== undefined) {
      this.onSendWhatsAppSubscription.unsubscribe();
    }
    if (this.checkGatewayPaymentStatusSubscription !== undefined) {
      this.checkGatewayPaymentStatusSubscription.unsubscribe();
    }
    if (this.paytmQrCodeSubscription !== undefined) {
      this.paytmQrCodeSubscription.unsubscribe();
    }
    if (this.paytmCollectPaySubscription !== undefined) {
      this.paytmCollectPaySubscription.unsubscribe();
    }
    if (this.paytmFetchPaymentSubscription !== undefined) {
      this.paytmFetchPaymentSubscription.unsubscribe();
    }
    if (this.getGatewaySetupSubscription !== undefined) {
      this.getGatewaySetupSubscription.unsubscribe();
    }
  }

  tabClicked(event: MatTabChangeEvent) {
    this.title = event.tab.textLabel;
    if (this.title == 'BANK') {
      this.getBankSetupDetails();
    }
    if (this.title == 'CARD') {
      this.getCardSetupDetails();
    }
    if (this.title == 'UPI') {
      this.getUpiSetupDetails();
    }
    if (this.title == 'WALLET') {
      this.getWalletHistory();
    }
  }

  getBankSetupDetails() {
    this.getBankSetupSubscription = this.shippingManagerService.getBankDataByLoc(this.apiFactory.getBankBankSetupByLoc, this.locationlocal).subscribe((data: any) => {
      this.bankBankSetup = data;
      this.setBankPaymentDetails();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getBankSetupDetails", error);
      });
  }

  getCardSetupDetails() {
    this.getCardSetupSubscription = this.shippingManagerService.getBankDataByLoc(this.apiFactory.getCardBankSetupByLoc, this.locationlocal).subscribe((data: any) => {
      this.cardBankSetup = data;
      this.setCardPaymentDetails();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getCardSetupDetails", error);
      });
  }

  getUpiSetupDetails() {
    this.getUpiSetupSubscription = this.shippingManagerService.getBankDataByLoc(this.apiFactory.getUpiBankSetupByLoc, this.locationlocal).subscribe((data: any) => {
      this.upiBankSetup = data;
      this.upiPaymentModeList = this.upiBankSetup.map(e => e.provider);
      this.setUpiPaymentDetails();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getUpiSetupDetails", error);
      });
  }

  createCollection() {
    this.createCollectionForm = this.formBuilder.group({
      amount: [],
      cashAmount: [],
      walletAmount: [],
      swipeAmount: [],
      gatewayAmount: [],
      gatewayCustomerMobileNo: [],
      upiPaymentMode: [],
      bankPayment: new UntypedFormArray([this.createBankPayment()]),
      cardPayment: new UntypedFormArray([this.createCardPayment()]),
      upiPayment: new UntypedFormArray([this.createUpiPayment()]),
      paytmPayment: new UntypedFormArray([this.createPaytmPayment()]),
      couponPayment: new UntypedFormArray([this.createCouponPayment()])
    });
  }

  //Bank Payment
  createBankPayment() {
    return this.formBuilder.group(
      {
        refNo: [],
        amount: ['', Validators.required],
        bankBranch: ['', Validators.required],
        bankName: ['', Validators.required],
        chequeDate: ['', Validators.required],
        chequeNoUTRNo: ['', Validators.required],
        ifscCode: [],
        bankAccountCode: [],
        bankRefCode: []
      });
  }
  get bankForm() { return this.createCollectionForm.controls; }
  get bankPaymentFormArray() {
    return this.bankForm.bankPayment as UntypedFormArray;
  }
  addBank() {
    this.bankPaymentFormArray.push(this.createBankPayment());
  }
  deleteBank(index: number) {
    this.bankPaymentFormArray.removeAt(index);
    let totalamt = 0;
    for (const iterator of this.bankPaymentFormArray.controls) {

      totalamt = totalamt + iterator.get('amount').value;
    }
    this.bank_amount_to_pay = totalamt;
    this.total_amt_bank = totalamt;
    this.calcBalance()
  }

  onBankPaymentOkClick() {
    if (this.bankPaymentFormArray.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }

    let totalamt = 0;
    let bankPayment = new BankPayment();

    for (const iterator of this.bankPaymentFormArray.controls) {

      let momentDate = new Date(iterator.get('chequeDate').value);
      let formattedDate = moment(momentDate).format("YYYY-MM-DD");

      let bankPaymentDetail = new BankPaymentDetailDto();
      bankPaymentDetail.refNo = iterator.get('refNo').value;
      bankPaymentDetail.amount = iterator.get('amount').value;
      bankPaymentDetail.bankBranch = iterator.get('bankBranch').value;
      bankPaymentDetail.bankName = iterator.get('bankName').value;
      bankPaymentDetail.chequeDate = formattedDate;
      bankPaymentDetail.chequeNoUTRNo = iterator.get('chequeNoUTRNo').value;
      bankPaymentDetail.ifscCode = iterator.get('ifscCode').value;
      bankPaymentDetail.bankAccountCode = this.bankBankSetup?.bank?.refNo;
      bankPaymentDetail.bankRefCode = iterator.get('bankRefCode').value;
      totalamt = totalamt + iterator.get('amount').value;

      bankPayment.refNo = this.transactionDetailPaymentsDto.bankPayment.refNo;
      bankPayment.bankPaymentDetails.push(bankPaymentDetail);
    }
    this.bank_amount_to_pay = totalamt;
    this.total_amt_bank = totalamt;
    this.refundAmt = 0;
    this.calcBalance();

    // if (this.refundAmt > 0) {
    //   this.total_amt_bank -= this.refundAmt;
    //   this.totalCalc();
    // }

    if (this.balance < 0) {
      this.total_amt_bank = totalamt + this.balance;
      this.totalCalc();
    }

    bankPayment.amount = this.total_amt_bank;
    this.transactionDetailPaymentsDto.bankPayment = bankPayment
    console.log(this.transactionDetailPaymentsDto)
  }

  setBankPaymentDetails() {
    if (this.transactionDetailPaymentsDto.bankPayment.bankPaymentDetails.length > 0) {
      this.bankPaymentFormArray.controls.pop();
    }
    this.total_amt_bank = 0;
    for (let element of this.transactionDetailPaymentsDto.bankPayment.bankPaymentDetails) {
      let fg = this.createBankPayment();
      fg.patchValue({
        refNo: element.refNo,
        amount: element.amount,
        bankBranch: element.bankBranch,
        bankName: element.bankName,
        chequeDate: element.chequeDate,
        chequeNoUTRNo: element.chequeNoUTRNo,
        ifscCode: element.ifscCode,
        bankAccountCode: element.bankAccountCode,
        bankRefCode: element.bankRefCode
      })
      this.total_amt_bank += element.amount;
      this.bankPaymentFormArray.push(fg);
    }
    this.calcBalance();
    return this.bankPaymentFormArray;
  }

  //Card Payment
  createCardPayment() {
    return this.formBuilder.group(
      {
        refNo: [],
        amount: ['', Validators.required],
        bankName: ['', Validators.required],
        date: ['', Validators.required],
        cardNo: ['', Validators.required],
        cardType: ['', Validators.required],
        cardHolderName: ['', Validators.required],
        transactionID: ['', Validators.required],
        cardCode: ['']
      });
  }
  get cardForm() { return this.createCollectionForm.controls; }
  get cardPaymentFormArray() {
    return this.cardForm.cardPayment as UntypedFormArray;
  }
  addCard() {
    this.cardPaymentFormArray.push(this.createCardPayment());
  }
  deleteCard(index: number) {
    this.cardPaymentFormArray.removeAt(index);
    let totalamt = 0;
    for (const iterator of this.cardPaymentFormArray.controls) {
      totalamt = totalamt + iterator.get('amount').value;
    }
    this.total_amt_card = totalamt;
    this.calcBalance();
    this.onCardPaymentOkClick();
  }
  onCardPaymentOkClick() {
    this.transactionDetailPaymentsDto.cardPayment = new CardPayment();
    if (this.cardPaymentFormArray.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }

    let cardPayment = new CardPayment();
    let totalamt = 0;

    for (const iterator of this.cardPaymentFormArray.controls) {

      let momentDate = new Date(iterator.get('date').value);
      let formattedDate = moment(momentDate).format("YYYY-MM-DD");

      let cardPaymentDetail = new CardPaymentDetailDto();

      cardPaymentDetail.amount = iterator.get('amount').value;
      cardPaymentDetail.bankName = iterator.get('bankName').value;
      cardPaymentDetail.date = formattedDate;
      cardPaymentDetail.cardNo = iterator.get('cardNo').value;
      cardPaymentDetail.cardType = iterator.get('cardType').value;
      cardPaymentDetail.cardHolderName = iterator.get('cardHolderName').value;
      cardPaymentDetail.transactionID = iterator.get('transactionID').value;
      cardPaymentDetail.cardCode = iterator.get('cardCode').value;
      totalamt = totalamt + iterator.get('amount').value;

      cardPayment.refNo = this.transactionDetailPaymentsDto.cardPayment.refNo;
      cardPayment.cardPaymentDetails.push(cardPaymentDetail);
    }
    this.total_amt_card = totalamt;
    this.refundAmt = 0;
    this.calcBalance();

    // if (this.refundAmt > 0) {
    //   this.total_amt_card = totalamt - this.refundAmt;
    //   this.totalCalc();
    // }

    if (this.balance < 0) {
      this.total_amt_card = totalamt + this.balance;
      this.totalCalc();
    }

    cardPayment.amount = this.total_amt_card;
    cardPayment.bankAccountCode = this.cardBankSetup?.bank?.refNo;
    this.transactionDetailPaymentsDto.cardPayment = cardPayment;
    console.log(this.transactionDetailPaymentsDto);
  }
  setCardPaymentDetails() {
    if (this.transactionDetailPaymentsDto.cardPayment.cardPaymentDetails.length > 0) {
      this.cardPaymentFormArray.controls.pop();
    }
    this.total_amt_card = 0;
    for (let element of this.transactionDetailPaymentsDto.cardPayment.cardPaymentDetails) {
      let fg = this.createCardPayment();
      fg.patchValue({
        amount: element.amount,
        bankName: element.bankName,
        date: element.date,
        cardNo: element.cardNo,
        cardType: element.cardType,
        cardHolderName: element.cardHolderName,
        transactionID: element.transactionID,
        refNo: element.refNo,
        cardCode: element.cardCode
      })
      this.total_amt_card += element.amount;
      this.cardPaymentFormArray.push(fg);
    }
    this.transactionDetailPaymentsDto.cardPayment.bankAccountCode = this.cardBankSetup?.bank?.refNo;
    this.calcBalance();
    return this.cardPaymentFormArray;
  }

  onUpiPaymentModeSelect(type: string) {
    this.upiPaymentMode = type;
    if (type == "ICICI") {
      this.resetPaytm();
      // this.onRemovePaytmCustomerClick();
    } else {
      this.resetUpi();
      // this.onRemoveUpiCustomerClick();
    }
  }

  //UPI Payment
  createUpiPayment() {
    return this.formBuilder.group(
      {
        refNo: [],
        customerName: [],
        customerMobile: [],
        amount: [],
        payerVA: [],
        transAmt: ['', Validators.required],
        merchantTranId: ['', Validators.required],
        customerCode: [],
        transStatus: [],
        txnInitDate: [],
        paymentAddress: [],
        bankRRN: [],
        paidAmount: [],
        upiCode: [],
        transDate: []
      });
  }
  get upiForm() { return this.createCollectionForm.controls; }
  get upiPaymentFormArray() {
    return this.upiForm.upiPayment as UntypedFormArray;
  }
  onUpiPaymentOkClick() {
    console.log(this.upiPaymentFormArray);
    if (this.upiPaymentFormArray.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    let upiPayment = new UpiPayment();

    for (const iterator of this.upiPaymentFormArray.controls) {

      let upiPaymentDetail = new UpiPaymentDetailDto();

      upiPaymentDetail.transAmt = iterator.get('transAmt').value;
      upiPaymentDetail.merchantTranId = iterator.get('merchantTranId').value;
      upiPaymentDetail.txnInitDate = moment(iterator.get('txnInitDate').value).format(this.constant.dateTimeFormatForDBServer);
      upiPaymentDetail.transStatus = iterator.get('transStatus').value;
      upiPaymentDetail.payerVA = iterator.get('payerVA').value;
      upiPaymentDetail.bankRRN = iterator.get('bankRRN').value;
      upiPaymentDetail.upiCode = iterator.get('upiCode').value;
      upiPaymentDetail.transDate = moment(iterator.get('transDate').value).format(this.constant.dateTimeFormatForDBServer);
      upiPaymentDetail.customerCode = this.UpiCustomerCode;
      this.upi_amount_to_pay = iterator.get('transAmt').value;
      this.total_amt_upi = iterator.get('transAmt').value;
      this.refundAmt = 0;
      this.calcBalance()

      upiPayment.refNo = this.transactionDetailPaymentsDto.upiPayment.refNo;
      upiPayment.upiPaymentDetails.push(upiPaymentDetail);
    }

    // if (this.refundAmt > 0) {
    //   this.total_amt_upi -= this.refundAmt;
    //   this.totalCalc();
    // }

    if (this.balance < 0) {
      this.total_amt_upi = this.total_amt_upi + this.balance;
      this.totalCalc();
    }

    upiPayment.amount = this.total_amt_upi;
    upiPayment.bankCode = this.upiBankSetup.filter(e => e.provider == "ICICI")[0]?.bank?.refNo;
    this.transactionDetailPaymentsDto.upiPayment = upiPayment;
    console.log(this.transactionDetailPaymentsDto);
  }

  setUpiPaymentDetails() {
    if (this.transactionDetailPaymentsDto.upiPayment.upiPaymentDetails.length > 0) {
      this.upiPaymentFormArray.controls.pop();
    }
    this.total_amt_upi = 0;
    for (let element of this.transactionDetailPaymentsDto.upiPayment.upiPaymentDetails) {
      let fg = this.createUpiPayment();
      fg.patchValue({
        transAmt: element.transAmt,
        merchantTranId: element.merchantTranId,
        txnInitDate: element.txnInitDate,
        transStatus: element.transStatus,
        payerVA: element.payerVA,
        bankRRN: element.bankRRN,
        refNo: element.refNo,
        upiCode: element.upiCode,
        transDate: element.transDate
      })
      this.total_amt_upi += element.transAmt;
      this.upiPaymentFormArray.push(fg);
    }
    this.transactionDetailPaymentsDto.upiPayment.bankCode = this.upiBankSetup.filter(e => e.provider == "ICICI")[0]?.bank?.refNo;
    this.calcBalance();
    return this.upiPaymentFormArray;
  }

  changeUpiStatus() {

  }

  //Paytm Payment
  createPaytmPayment() {
    return this.formBuilder.group(
      {
        refNo: [],
        linkId: ['', Validators.required],
        orderId: ['', Validators.required],
        amount: ['', Validators.required],
        transStatus: [],
        customerCode: ['']
      });
  }
  get paytmForm() { return this.createCollectionForm.controls; }
  get paytmPaymentFormArray() {
    return this.paytmForm.paytmPayment as UntypedFormArray;
  }

  onPaytmPaymentOkClick() {
    if (this.paytmPaymentFormArray.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    let paytmPayment = new PaytmPaymentDto();

    for (const iterator of this.paytmPaymentFormArray.controls) {
      paytmPayment.linkId = iterator.get('linkId').value;
      paytmPayment.orderId = iterator.get('orderId').value;
      paytmPayment.amount = iterator.get('amount').value;
      paytmPayment.refNo = iterator.get('refNo').value;
      paytmPayment.customerCode = this.PaytmCustomerCode;

      this.paytm_amount_to_pay = iterator.get('amount').value;
      this.total_amt_paytm = iterator.get('amount').value;
      this.refundAmt = 0;
      this.calcBalance()
    }
    // if (this.refundAmt > 0) {
    //   this.total_amt_paytm -= this.refundAmt;
    //   this.totalCalc();
    // }

    if (this.balance < 0) {
      this.total_amt_paytm = this.total_amt_paytm + this.balance;
      this.totalCalc();
    }

    paytmPayment.amount = this.total_amt_paytm;
    this.transactionDetailPaymentsDto.paytmPayment = paytmPayment;
    console.log(this.transactionDetailPaymentsDto);
  }

  setPaytmPaymentDetails() {
    if (this.transactionDetailPaymentsDto.paytmPayment != null) {
      this.paytmPaymentFormArray.controls.pop();
    }
    this.total_amt_paytm = 0;
    let element = this.transactionDetailPaymentsDto.paytmPayment
    let fg = this.createPaytmPayment();
    fg.patchValue({
      linkId: element.linkId,
      orderId: element.orderId,
      amount: element.amount,
      refNo: element.refNo
    })
    this.total_amt_paytm = element.amount;
    this.paytmPaymentFormArray.push(fg);
    this.calcBalance();
    return this.paytmPaymentFormArray;
  }

  //Coupon Payment
  createCouponPayment() {
    return this.formBuilder.group(
      {
        refNo: [],
        couponCode: ['', Validators.required],
        couponAmount: ['', Validators.required],
        couponPaymentCode: ['']
      });
  }
  get couponForm() { return this.createCollectionForm.controls; }
  get couponPaymentFormArray() {
    return this.couponForm.couponPayment as UntypedFormArray;
  }
  addCoupon() {
    if (this.balance > 0)
      this.couponPaymentFormArray.push(this.createCouponPayment());
  }
  deleteCoupon(index: number) {
    this.couponPaymentFormArray.removeAt(index);
    this.couponAmount[index] = undefined;
    this.totalCouponAmount = 0
    for (const iterator of this.couponPaymentFormArray.controls) {
      if (iterator.get('couponAmount').value >= 0)
        this.totalCouponAmount = this.totalCouponAmount + iterator.get('couponAmount').value;
    }
    this.coupon_amount_to_pay = this.totalCouponAmount;
    this.total_amt_coupon = this.totalCouponAmount;
    this.calcBalance()
    this.onCouponPaymentOkClick();
  }

  onCouponCodeChange(code: string, index: number) {
    if (this.couponPaymentFormArray.controls.filter(e => e.get('couponCode').value == code).length > 1) {
      this.toastService.showErrorToast(this.constant.duplicateCouponCode);
      return;
    }
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();
      // this.totalCouponAmount = 0 
      code = code.toString().trim();
      if (code) {
        this.getCouponAmountSubscription = this.shippingManagerService.getCouponAmount(this.apiFactory.getCouponAmount, code, this.locationlocal).subscribe((response: any) => {
          const applicableCouponAmt: number = Math.min(Number(response.data), this.balance);
          this.couponAmount[index] = applicableCouponAmt;
          this.couponPaymentFormArray.at(index).get('couponAmount').setValue(applicableCouponAmt);
        },
          (error: HttpErrorResponse) => {
            this.insertErrorLog("onCouponCodeChange", error);
          });
      }
    });
  }

  onCouponPaymentOkClick() {
    this.transactionDetailPaymentsDto.couponPayment = new CouponPayment();
    if (this.couponPaymentFormArray.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }

    this.totalCouponAmount = 0
    let couponPayment = new CouponPayment();

    for (const iterator of this.couponPaymentFormArray.controls) {
      let couponPaymentDetail = new CouponPaymentDetail();
      couponPaymentDetail.refNo = iterator.get('refNo').value;
      couponPaymentDetail.couponCode = iterator.get('couponCode').value.trim();
      couponPaymentDetail.amount = iterator.get('couponAmount').value;
      couponPaymentDetail.couponPaymentCode = iterator.get('couponPaymentCode').value;

      if (iterator.get('couponAmount').value >= 0) {
        this.totalCouponAmount = this.totalCouponAmount + iterator.get('couponAmount').value;
      }
      couponPayment.refNo = this.transactionDetailPaymentsDto.couponPayment.refNo;
      couponPayment.couponPaymentDetails.push(couponPaymentDetail);
    }

    this.coupon_amount_to_pay = this.totalCouponAmount;
    this.total_amt_coupon = this.totalCouponAmount;
    this.refundAmt = 0;
    this.calcBalance();

    // if (this.refundAmt > 0) {
    //   this.total_amt_coupon = this.totalCouponAmount - this.refundAmt;
    //   this.totalCalc();
    // }

    if (this.balance < 0) {
      this.total_amt_coupon = this.totalCouponAmount + this.balance;
      this.totalCalc();
    }

    couponPayment.amount = this.total_amt_coupon;
    this.transactionDetailPaymentsDto.couponPayment = couponPayment
    console.log(this.transactionDetailPaymentsDto)
  }
  setCouponPaymentDetails() {
    if (this.transactionDetailPaymentsDto.couponPayment.couponPaymentDetails.length > 0) {
      this.couponPaymentFormArray.controls.pop();
    }
    this.total_amt_coupon = 0;
    let i = 0;
    for (let element of this.transactionDetailPaymentsDto.couponPayment.couponPaymentDetails) {
      let fg = this.createCouponPayment();
      fg.patchValue({
        refNo: element.refNo,
        couponAmount: element.amount,
        couponCode: element.couponCode,
        couponPaymentCode: element.couponPaymentCode
      })
      this.total_amt_coupon += element.amount;
      this.couponPaymentFormArray.push(fg);
      this.couponAmount[i++] = element.amount;
    }
    this.calcBalance();
    return this.couponPaymentFormArray;
  }

  getAmount(amt: number) {
    this.Amount = amt;
    this.createCollectionForm.get('cashAmount').setValue(amt);
    // this.balance = this.amountToPay - amt;
    // this.total_amt_cash = amt;
    // this.calcBalance()

  }
  onCashAmountChange(amt: any) {
    // this.total_amt_cash = amt.target.value;
    // this.calcBalance()
  }
  onUpiAmountChange(amt: any) {
    this.upiAmount = amt.target.value;
    // this.upi_amount_to_pay = amt.target.value;
    // this.total_amt_upi = amt.target.value;
    // this.calcBalance()
  }
  onPaytmAmountChange(amt: any) {
    this.paytmAmount = amt.target.value;
    // this.paytm_amount_to_pay = amt.target.value;
    // this.total_amt_paytm = amt.target.value;
    // this.calcBalance()
  }
  onBankAmountChange(amt: any) {
    // let totalamt = 0;
    // for (const iterator of this.bankPaymentFormArray.controls) {
    //   totalamt = totalamt + iterator.get('amount').value;
    // }
    // this.bank_amount_to_pay = totalamt;
    // this.total_amt_bank = totalamt;
    // this.calcBalance()
  }
  onCouponAmountChange(amt: any) {
    // this.coupon_amount_to_pay = amt.target.value;
    // this.total_amt_coupon = amt.target.value;
    // this.calcBalance()
  }
  onCardAmountChange() {
    // let totalamt = 0;
    // for (const iterator of this.cardPaymentFormArray.controls) {
    //   totalamt = totalamt + iterator.get('amount').value;
    // }
    // this.total_amt_card = totalamt;
    // this.calcBalance()
  }
  onSwipeAmountChange(amt: any) {
    this.createCollectionForm.get('swipeAmount').setValue(amt.target.value);
  }
  onGatewayAmountChange(amt: any) {
    this.createCollectionForm.get('gatewayAmount').setValue(amt.target.value);
  }
  onUpiSelectCustomerClick() {
    this.upiCustomerSelected.locationCode = this.locationlocal;
    this.upiCustomerSelected.companyCode = this.companyCode;
    let dialogRef = this.dialog.open(CreateOrderCustomerComponent, {
      width: '950px',
      height: '566px',
      maxWidth: '90%',
      data: { selectedCustomer: this.upiCustomerSelected }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.upiCustomerSelected = res.data;

      if (this.upiCustomerSelected.customerName != null) {
        this.isUpiSelectedCustomer = true;
        this.UpiCustomerName = this.upiCustomerSelected.customerName;
        this.UpiCustomerMobileNo = this.upiCustomerSelected.customerMobile;
        this.UpiCustomerCode = this.upiCustomerSelected.refNo;
      }
    })
  }
  onRemoveUpiCustomerClick() {
    this.upiCustomerSelected = new Customer();
    this.isUpiSelectedCustomer = false;
    this.UpiCustomerName = null;
    this.UpiCustomerMobileNo = null;
    this.UpiCustomerCode = null;
  }

  onPaytmSelectCustomerClick() {
    let dialogRef = this.dialog.open(CreateOrderCustomerComponent, {
      width: '950px',
      height: '566px',
      maxWidth: '90%',
      data: { selectedCustomer: this.paytmCustomerSelected }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.paytmCustomerSelected = res.data;

      if (this.paytmCustomerSelected.customerName != null) {
        this.isPaytmSelectedCustomer = true;
        this.PaytmCustomerName = this.paytmCustomerSelected.customerName;
        this.PaytmCustomerMobileNo = this.paytmCustomerSelected.customerMobile;
        this.PaytmCustomerCode = this.paytmCustomerSelected.refNo;
      }
    })
  }
  onRemovePaytmCustomerClick() {
    this.paytmCustomerSelected = null;
    this.isPaytmSelectedCustomer = false;
    this.PaytmCustomerName = null;
    this.PaytmCustomerMobileNo = null;
    this.PaytmCustomerCode = null;
  }

  calcBalance() {
    this.total_amt_byAllTypes = Number(this.total_amt_cash) + Number(this.total_amt_upi) + Number(this.total_amt_paytm) + Number(this.total_amt_bank)
      + Number(this.total_amt_coupon) + Number(this.total_amt_card) + Number(this.total_amt_wallet) + Number(this.total_amt_swipe) + Number(this.total_amt_gateway);
    this.balance = Number((this.amountToPay - this.total_amt_byAllTypes).toFixed(2));

    // added return amount before edit 'this.balance = Number(this.balance.toFixed(2));' back up
    if (this.balance < 0) {
      this.refundAmt = Number(Math.abs(this.balance).toFixed(2));
      this.transactionDetailPaymentsDto.refundAmt = this.refundAmt;
    } else {
      this.transactionDetailPaymentsDto.refundAmt = 0;

      this.sortedAmt = [];
      this.denomination = [500, 200, 100, 50, 20, 10, 5, 2, 1];
      this.amt = [];
      this.onCreateDenominations(this.balance);
    }

    this.transactionDtls.totalAmtByAllTypes = this.total_amt_byAllTypes;
    this.transactionDtls.balance = this.balance;
    this.transactionDetailPaymentsDto.amount = this.total_amt_byAllTypes;

  }
  totalCalc() {
    this.total_amt_byAllTypes = Number(this.total_amt_cash) + Number(this.total_amt_upi) + Number(this.total_amt_paytm) + Number(this.total_amt_bank)
      + Number(this.total_amt_coupon) + Number(this.total_amt_card) + Number(this.total_amt_wallet) + Number(this.total_amt_swipe) + Number(this.total_amt_gateway);
    // this.balance = Number((this.amountToPay - this.total_amt_byAllTypes).toFixed(2));

    this.transactionDtls.totalAmtByAllTypes = this.total_amt_byAllTypes;
    this.transactionDetailPaymentsDto.amount = this.total_amt_byAllTypes;
    // this.transactionDtls.balance = this.balance;
    this.transactionDtls.refundAmt = this.refundAmt;
  }
  onPayeeVaChange(payee: any) {
    this.PayeeVA = payee.target.value;
  }
  onMessageLinkDescChange(mess: any) {
    this.PaytmMessageDesc = mess.target.value;
  }
  sendSMSIntent() {
    if (this.upiAmount != 0) {
      this.sendSmsSubscription = this.shippingManagerService.sendSms(this.apiFactory.sendSmsForUpi, this.UpiCustomerCode, this.upiAmount, this.locationlocal).subscribe((response: any) => {
        if (null != response.data) {
          this.toastService.showSuccessToast(this.constant.SmsToast);
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("sendSMSIntent", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.enterAmountToast);
    }
  }

  //UPI
  generateQRCode() {
    if (this.UpiCustomerName.length > 0 && this.UpiCustomerMobileNo.length > 0 && this.upiAmount > 0) {
      this.qrCodeSubscription = this.shippingManagerService.getQrCode(this.apiFactory.getQrForUpi, this.locationlocal, this.upiAmount, this.paymentType).subscribe((data: any) => {
        if (null != data) {
          this.upiCodeResponse = data;
          this.generatedQRCode = this.upiCodeResponse.qrString;
          this.merchantTnxId = this.upiCodeResponse.merchantTnxId;
          // this.upiPaymentFormArray.controls[0].get('merchantTranId').setValue(this.merchantTnxId);
          this.showQrCodeLabel = false;
          this.showQrCode = true;
          this.sendUpiEmiterRequest(this.merchantTnxId);
        }
        else {
          this.showQrCodeLabel = true;
          this.showQrCode = false;
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("generateQRCode", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.provideAllValueToast);
    }
  }

  sendCollectPayRequest() {
    this.collectPayReq = new CollectPayReq()
    this.collectPayReq.amount = this.upiAmount;
    this.collectPayReq.locId = this.locationlocal;
    this.collectPayReq.paymentType = this.paymentType;
    this.collectPayReq.payerVa = this.PayeeVA;
    console.log(this.collectPayReq)
    if (this.collectPayReq.amount != 0 && this.collectPayReq.payerVa != '') {
      this.collectPaySubscription = this.shippingManagerService.collectPayByVPA(this.apiFactory.collectPayByVpa, this.collectPayReq).subscribe((data: any) => {
        if (data) {
          this.merchantTnxId = data;
          // this.upiPaymentFormArray.controls[0].get('merchantTranId').setValue(this.merchantTnxId);
          console.log(this.merchantTnxId)
          this.toastService.showSuccessToast(this.constant.paymentRequestToast);
          this.sendUpiEmiterRequest(this.merchantTnxId);
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("sendCollectPayRequest", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.enterAmountandPayToast);
    }
  }

  sendUpiEmiterRequest(merchantTranId: string) {
    const eventSource = new EventSource(this.apiFactory.initiateNotification + merchantTranId);
    eventSource.addEventListener('message', (e) => {
      console.log(e.data);
      console.log(JSON.stringify(e.data));
      if (JSON.stringify(e.data).includes('Success :')) {
        this.onFetchPaymentClick();
      }
      else {
        console.log(JSON.stringify(e.data));
        this.upiCodeResponse = new UpiCodeResponse();
        this.generatedQRCode = '';
        this.merchantTnxId = '';
        this.showQrCodeLabel = true;
        this.showQrCode = false;
        this.toastService.showErrorToast(this.constant.paymentFailedToast);
      }
      eventSource.close();
    });
  }

  onFetchPaymentClick() {
    this.fetchPaymentSubscription = this.shippingManagerService.getTransactionDetails(this.apiFactory.fetchUpiPaymentDetails, this.merchantTnxId, this.locationlocal).subscribe((data: any) => {
      this.upiPaymentDetails = data;
      console.log(this.upiPaymentDetails);
      for (const iterator of this.upiPaymentFormArray.controls) {
        iterator.patchValue({ "merchantTranId": this.upiPaymentDetails.merchantTranId });
        iterator.patchValue({ "payerVA": this.upiPaymentDetails.payerVA });
        iterator.patchValue({ "transAmt": this.upiPaymentDetails.amount });
        iterator.patchValue({ "bankRRN": this.upiPaymentDetails.originalBankRRN });
        iterator.patchValue({ "txnInitDate": this.upiPaymentDetails.txnInitDate });
        iterator.patchValue({ "transDate": this.upiPaymentDetails.txnCompletionDate });
        iterator.patchValue({ "transStatus": this.upiPaymentDetails.status });
      }
      this.upiPaymentDetail = new UpiPaymentDetailDto();
      this.upiPaymentDetail.transAmt = this.upiPaymentDetails.amount;
      this.upiPaymentDetail.merchantTranId = this.upiPaymentDetails.merchantTranId;
      this.merchantTranId = data.merchantTranId
      this.transAmt = data.amount
      if (data.status == "SUCCESS") {
        this.status = true
        this.toastService.showSuccessToast(this.constant.paymentSuccessToast);
      }
      else
        this.status = false
      this.txnCompletionDate = data.txnCompletionDate;
      this.upiPaymentDetail.customerCode = this.UpiCustomerCode;
      this.upiPaymentDetail.transStatus = this.upiPaymentDetails.status;
      this.transactionStatus = this.upiPaymentDetails.status;
      this.upiPaymentDetail.txnInitDate = this.upiPaymentDetails.txnInitDate;

      this.payerVA = data.payerVA
      this.originalBankRRN = data.originalBankRRN
      this.upiPaymentDetailDto.push(this.upiPaymentDetail);

      this.upiPaymentDto.upiPaymentDetailDto = this.upiPaymentDetailDto;
      this.collectionDto.upiPaymentDto = this.upiPaymentDto;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onFetchPaymentClick", error);
      });
  }

  //Paytm
  generatePaytmQRCode() {
    if (this.PaytmCustomerName.length > 0 && this.PaytmCustomerMobileNo.length > 0 && this.paytmAmount > 0) {
      this.merchantTnxIdPaytm = this.getSwipeTransNo();
      this.paytmQrCodeSubscription = this.shippingManagerService.getQrCodePaytm(this.apiFactory.getQrForPaytm, this.paytmAmount.toString(), this.merchantTnxIdPaytm).subscribe((data: any) => {
        console.log(data)
        if (null != data) {
          this.generatedQRCodePaytm = data.body.qrData;
          this.showQrCodeLabelPaytm = false;
          this.showQrCodePaytm = true;
          // this.sendPaytmEmiterRequest(this.merchantTnxIdPaytm);
        }
        else {
          this.showQrCodeLabelPaytm = true;
          this.showQrCodePaytm = false;
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("generatePaytmQRCode", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.provideAllValueToast);
    }
  }

  sendPaymtmCollectPayRequest() {
    if (this.PaytmCustomerName.length > 0 && this.PaytmCustomerMobileNo.length > 0 && this.paytmAmount > 0) {
      this.paytmCollectPaySubscription = this.shippingManagerService.sendPaymentRequestLink(this.apiFactory.collectPayByVpaPaytm, this.PaytmCustomerMobileNo).subscribe((data: any) => {
        console.log(data)
        if (data) {
          this.merchantTnxIdPaytm = data;
          this.paytmForm.createUpiPayment.get('orderId').setValue(this.merchantTnxIdPaytm);

          console.log(this.merchantTnxIdPaytm)
          this.toastService.showSuccessToast(this.constant.paymentRequestToast);
          // this.sendPaytmEmiterRequest(this.merchantTnxIdPaytm);
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("sendCollectPayRequest", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.EnterAmtandCustomerToast);
    }
  }

  sendPaytmEmiterRequest(merchantTranId: string) {
    const eventSource = new EventSource(this.apiFactory.initiateNotification + merchantTranId);
    eventSource.addEventListener('message', (e) => {
      console.log(e.data);
      console.log(JSON.stringify(e.data));
      if (JSON.stringify(e.data).includes('Success :')) {
        this.onPaytmFetchPaymentClick();
      }
      else {
        console.log(JSON.stringify(e.data));
      }
      eventSource.close();
    });
  }

  onPaytmFetchPaymentClick() {
    this.paytmFetchPaymentSubscription = this.shippingManagerService.getTransactionDetails(this.apiFactory.fetchPaytmPaymentDetails, this.merchantTnxIdPaytm, this.locationlocal).subscribe((data: any) => {
      //   this.upiPaymentDetails = data;
      //   console.log(this.upiPaymentDetails)

      //   // for (const iterator of this.upiPaymentFormArray.controls) {
      //   //   iterator.patchValue({ "merchantTranId": this.upiPaymentDetails.merchantTranId });
      //   //   iterator.patchValue({ "paymentAddress": this.upiPaymentDetails.payerVA });
      //   //   iterator.patchValue({ "paidAmount": this.upiPaymentDetails.amount });
      //   //   iterator.patchValue({ "bankRRN": this.upiPaymentDetails.originalBankRRN });
      //   // }
      //   this.upiPaymentDetail = new UpiPaymentDetailDto();
      //   this.upiPaymentDetail.transAmt = this.upiPaymentDetails.amount;
      //   this.upiPaymentDetail.merchantTranId = this.upiPaymentDetails.merchantTranId;
      //   this.merchantTranId = data.merchantTranId
      //   this.transAmt = data.amount
      //   if (data.status == "SUCCESS")
      //     this.statusPaytm = true
      //   else
      //     this.statusPaytm = false
      //   this.txnCompletionDate = data.txnCompletionDate
      //   this.upiPaymentDetail.customerCode = this.UpiCustomerCode;
      //   this.upiPaymentDetail.transStatus = this.upiPaymentDetails.status;
      //   this.transactionStatus = this.upiPaymentDetails.status;
      //   this.upiPaymentDetail.txnInitDate = this.upiPaymentDetails.txnInitDate;

      //   this.payerVA = data.payerVA
      //   this.originalBankRRN = data.originalBankRRN
      //   this.upiPaymentDetailDto.push(this.upiPaymentDetail);

      //   this.upiPaymentDto.upiPaymentDetailDto = this.upiPaymentDetailDto;
      //   this.collectionDto.upiPaymentDto = this.upiPaymentDto;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onPaytmFetchPaymentClick", error);
      });
  }

  // initiatePayment() {
  //   if (this.PaytmCustomerName.length > 0 && this.PaytmCustomerMobileNo.length > 0 && this.paytmAmount > 0 && this.PaytmMessageDesc.length > 0) {
  //     this.paytmRequestDto.amount = this.paytmAmount
  //     this.paytmRequestDto.customerName = this.PaytmCustomerCode
  //     this.paytmRequestDto.locId = this.locationlocal
  //     this.paytmRequestDto.customerEmail = "sss@gmail.com"
  //     this.paytmRequestDto.message = this.PaytmMessageDesc
  //     this.paytmRequestDto.customerMobile = this.PaytmCustomerMobileNo
  //     this.collectService.PaytmPaymentRequest(this.apiFactory.initiatepayment, this.paytmRequestDto).subscribe((data: any) => {
  //       this.toastService.showSuccessToast("Paytm Link Sent Successfully");
  //     })
  //   }
  //   else {
  //     this.toastService.showErrorToast("Enter All Information");
  //   }
  // }

  // FetchPayTmPayment() {
  //   this.collectService.PaytmFetchPayment(this.apiFactory.fetchpayment, "3899837893", this.locationlocal).subscribe((data: any) => {
  //     this.toastService.showSuccessToast("Paytm Link Sent Successfully");
  //   })
  // }

  resetCash() {
    this.createCollectionForm.get('cashAmount').reset();
    this.total_amt_cash = this.createCollectionForm.get('cashAmount').value;
    if (this.transactionDetailPaymentsDto.cashPayment.refNo) {
      this.transactionDetailPaymentsDto.cashPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.cashPayment = new CashPayment();
    }
    this.calcBalance()
  }
  resetUpi() {
    this.upiCodeResponse = new UpiCodeResponse();
    this.generatedQRCode = '';
    this.merchantTnxId = '';
    this.showQrCodeLabel = true;
    this.showQrCode = false;

    this.upiPaymentFormArray.reset();
    this.upi_amount_to_pay = 0;
    this.upiAmount = 0;
    this.total_amt_upi = 0;
    if (this.transactionDetailPaymentsDto.upiPayment.refNo) {
      this.transactionDetailPaymentsDto.upiPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.upiPayment = new UpiPayment();
    }
    this.calcBalance()
  }
  resetPaytm() {
    this.paytmPaymentFormArray.reset();
    this.paytm_amount_to_pay = 0;
    this.paytmAmount = 0;
    this.total_amt_paytm = 0;
    if (this.transactionDetailPaymentsDto.paytmPayment.refNo) {
      this.transactionDetailPaymentsDto.paytmPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.paytmPayment = new PaytmPaymentDto();
    }
    this.calcBalance()
  }
  resetBank() {
    this.bankPaymentFormArray.reset();
    this.bankPaymentFormArray.controls = [];
    this.addBank();
    this.bank_amount_to_pay = 0;
    this.total_amt_bank = 0;
    if (this.transactionDetailPaymentsDto.bankPayment.refNo) {
      this.transactionDetailPaymentsDto.bankPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.bankPayment = new BankPayment();
    }
    this.calcBalance()
  }
  resetCard() {
    this.cardPaymentFormArray.reset();
    this.cardPaymentFormArray.controls = [];
    this.addCard();
    this.total_amt_card = 0;
    if (this.transactionDetailPaymentsDto.cardPayment.refNo) {
      this.transactionDetailPaymentsDto.cardPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.cardPayment = new CardPayment();
    }
    this.calcBalance()
  }
  resetCoupon() {
    this.couponPaymentFormArray.reset();
    this.couponPaymentFormArray.controls = [];
    this.addCoupon();
    this.couponAmount = [];
    this.coupon_amount_to_pay = 0;
    this.total_amt_coupon = 0;
    if (this.transactionDetailPaymentsDto.couponPayment.refNo) {
      this.transactionDetailPaymentsDto.couponPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.couponPayment = new CouponPayment();
    }
    this.calcBalance()
  }
  resetWallet() {
    this.createCollectionForm.get('walletAmount').reset();
    this.total_amt_wallet = this.createCollectionForm.get('walletAmount').value;
    this.useableWalletBalance = Number((this.walletBalance - this.total_amt_wallet).toFixed(2));

    if (this.transactionDetailPaymentsDto.walletPayment.refNo) {
      this.transactionDetailPaymentsDto.walletPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.walletPayment = new WalletPayment();
    }
    this.calcBalance()
  }
  resetSwipe() {
    this.createCollectionForm.get('swipeAmount').reset();
    this.total_amt_swipe = this.createCollectionForm.get('swipeAmount').value;
    if (this.transactionDetailPaymentsDto.swipePayment.refNo) {
      this.transactionDetailPaymentsDto.swipePayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.swipePayment = new SwipePayment();
    }
    this.calcBalance()
  }
  resetGateway() {
    this.createCollectionForm.get('gatewayAmount').reset();
    this.createCollectionForm.get('gatewayCustomerMobileNo').reset();
    this.total_amt_gateway = this.createCollectionForm.get('gatewayAmount').value;
    if (this.transactionDetailPaymentsDto.gatewayPayment.refNo) {
      this.transactionDetailPaymentsDto.gatewayPayment.amount = 0;
    } else {
      this.transactionDetailPaymentsDto.gatewayPayment = new GatewayPayment();
    }
    this.calcBalance()
  }

  onCashPaymentOkClick() {
    if (!this.createCollectionForm.get('cashAmount').value) {
      this.createCollectionForm.get('cashAmount').setValue(0);
    }
    this.total_amt_cash = this.createCollectionForm.get('cashAmount').value;
    // this.refundAmt = 0;
    this.calcBalance();

    if (this.balance < 0) {
      this.total_amt_cash = Number(this.createCollectionForm.get('cashAmount').value) + this.balance;
      this.totalCalc();
    }

    let cashPayment = new CashPayment();
    cashPayment.amount = this.total_amt_cash;
    cashPayment.refNo = this.transactionDetailPaymentsDto.cashPayment.refNo;
    this.transactionDetailPaymentsDto.cashPayment = cashPayment;
  }

  onWalletPaymentOkClick() {
    // if (this.createCollectionForm.get('walletAmount').value <= this.useableWalletBalance) {
    if (!this.createCollectionForm.get('walletAmount').value) {
      this.createCollectionForm.get('walletAmount').setValue(0);
    }
    this.total_amt_wallet = this.createCollectionForm.get('walletAmount').value;
    this.useableWalletBalance = Number((this.walletBalance - this.total_amt_wallet).toFixed(2));
    // this.refundAmt = 0;
    this.calcBalance();

    if (this.balance < 0) {
      this.total_amt_wallet = Number(this.createCollectionForm.get('walletAmount').value) + this.balance;
      this.totalCalc();
    }

    let walletPayment = new WalletPayment();
    walletPayment.amount = this.total_amt_wallet;
    walletPayment.refNo = this.transactionDetailPaymentsDto.walletPayment.refNo;
    walletPayment.appliedOfferList = this.offerList;
    this.transactionDetailPaymentsDto.walletPayment = walletPayment;
    // } else {
    //   this.createCollectionForm.get('walletAmount').setValue(this.useableWalletBalance);
    // }
  }

  onSwipePaymentOkClick() {
    if (!this.createCollectionForm.get('swipeAmount').value) {
      this.createCollectionForm.get('swipeAmount').setValue(0);
    }
    this.total_amt_swipe = this.createCollectionForm.get('swipeAmount').value;
    this.calcBalance();

    if (this.balance < 0) {
      this.total_amt_swipe = Number(this.createCollectionForm.get('swipeAmount').value) + this.balance;
      this.totalCalc();
    }

    let swipePayment = new SwipePayment();
    swipePayment.amount = this.total_amt_swipe;
    swipePayment.refNo = this.transactionDetailPaymentsDto.swipePayment.refNo;
    swipePayment.swipePaymentResponseCode = this.paytmPaymentResponseCode;
    swipePayment.paymentType = "Paytm";
    this.transactionDetailPaymentsDto.swipePayment = swipePayment;
  }

  onGatewayPaymentOkClick() {
    if (!this.createCollectionForm.get('gatewayAmount').value) {
      this.createCollectionForm.get('gatewayAmount').setValue(0);
    }
    this.total_amt_gateway = this.createCollectionForm.get('gatewayAmount').value;
    this.calcBalance();

    if (this.balance < 0) {
      this.total_amt_gateway = Number(this.createCollectionForm.get('gatewayAmount').value) + this.balance;
      this.totalCalc();
    }

    let gatewayPayment = new GatewayPayment();
    gatewayPayment.amount = this.total_amt_gateway;
    gatewayPayment.refNo = this.transactionDetailPaymentsDto.gatewayPayment.refNo;
    gatewayPayment.gatewayPaymentResponseCode = this.gatewayPaymentResponseCode;
    gatewayPayment.paymentType = "CCAvenue";
    this.transactionDetailPaymentsDto.gatewayPayment = gatewayPayment;
  }

  final_amt(event: any) {

    let bankPayment = new BankPayment()
    let bankPaymentDetail = new BankPaymentDetailDto()
    bankPaymentDetail.amount = this.bank_amount_to_pay
    bankPaymentDetail.bankBranch = this.bankBranch
    bankPaymentDetail.bankName = this.bankName
    bankPaymentDetail.chequeDate = this.chequeDate
    bankPaymentDetail.chequeNoUTRNo = this.chequeNoUTRNo
    bankPaymentDetail.ifscCode = this.ifscCode
    bankPayment.amount = this.bank_amount_to_pay
    bankPayment.bankPaymentDetails.push(bankPaymentDetail)
    this.transactionDetailPaymentsDto.bankPayment = bankPayment

  }
  setCashPaymentDetails() {
    this.createCollectionForm.get('cashAmount').setValue(this.transactionDetailPaymentsDto.cashPayment.amount);

    if (this.transactionDetailPaymentsDto.cashPayment.amount > 0 && this.dialogData.trnsactionDto.refundAmt > 0)
      this.createCollectionForm.get('cashAmount').setValue(this.transactionDetailPaymentsDto.cashPayment.amount + this.dialogData.trnsactionDto.refundAmt);

    this.total_amt_cash = this.transactionDetailPaymentsDto.cashPayment.amount;
    this.total_amt_bank = this.transactionDetailPaymentsDto.bankPayment.amount
    this.total_amt_card = this.transactionDetailPaymentsDto.cardPayment.amount
    this.total_amt_coupon = this.transactionDetailPaymentsDto.couponPayment.amount
    this.total_amt_paytm = this.transactionDetailPaymentsDto.paytmPayment.amount
    this.total_amt_upi = this.transactionDetailPaymentsDto.upiPayment.amount
    this.total_amt_wallet = this.transactionDetailPaymentsDto.walletPayment.amount
    this.total_amt_swipe = this.transactionDetailPaymentsDto.swipePayment.amount
    this.total_amt_gateway = this.transactionDetailPaymentsDto.gatewayPayment.amount

    this.calcBalance()
  }

  setWalletPaymentDetails() {
    this.createCollectionForm.get('walletAmount').setValue(this.transactionDetailPaymentsDto.walletPayment.amount);

    if (this.transactionDetailPaymentsDto.walletPayment.amount > 0 && this.dialogData.trnsactionDto.refundAmt > 0)
      this.createCollectionForm.get('walletAmount').setValue(this.transactionDetailPaymentsDto.walletPayment.amount + this.dialogData.trnsactionDto.refundAmt);

    this.total_amt_cash = this.transactionDetailPaymentsDto.cashPayment.amount;
    this.total_amt_bank = this.transactionDetailPaymentsDto.bankPayment.amount
    this.total_amt_card = this.transactionDetailPaymentsDto.cardPayment.amount
    this.total_amt_coupon = this.transactionDetailPaymentsDto.couponPayment.amount
    this.total_amt_paytm = this.transactionDetailPaymentsDto.paytmPayment.amount
    this.total_amt_upi = this.transactionDetailPaymentsDto.upiPayment.amount
    this.total_amt_wallet = this.transactionDetailPaymentsDto.walletPayment.amount
    this.total_amt_swipe = this.transactionDetailPaymentsDto.swipePayment.amount
    this.total_amt_gateway = this.transactionDetailPaymentsDto.gatewayPayment.amount

    this.calcBalance()
  }

  setSwipePaymentDetails() {
    this.createCollectionForm.get('swipeAmount').setValue(this.transactionDetailPaymentsDto.swipePayment.amount);

    if (this.transactionDetailPaymentsDto.swipePayment.amount > 0) {
      this.paytmPaymentResponseCode = this.transactionDetailPaymentsDto.swipePayment.swipePaymentResponseCode;
      if (this.dialogData.trnsactionDto.refundAmt > 0)
        this.createCollectionForm.get('swipeAmount').setValue(this.transactionDetailPaymentsDto.swipePayment.amount + this.dialogData.trnsactionDto.refundAmt);
    }
    this.total_amt_cash = this.transactionDetailPaymentsDto.cashPayment.amount;
    this.total_amt_bank = this.transactionDetailPaymentsDto.bankPayment.amount
    this.total_amt_card = this.transactionDetailPaymentsDto.cardPayment.amount
    this.total_amt_coupon = this.transactionDetailPaymentsDto.couponPayment.amount
    this.total_amt_paytm = this.transactionDetailPaymentsDto.paytmPayment.amount
    this.total_amt_upi = this.transactionDetailPaymentsDto.upiPayment.amount
    this.total_amt_wallet = this.transactionDetailPaymentsDto.walletPayment.amount
    this.total_amt_swipe = this.transactionDetailPaymentsDto.swipePayment.amount
    this.total_amt_gateway = this.transactionDetailPaymentsDto.gatewayPayment.amount

    this.calcBalance()
  }

  setGatewayPaymentDetails() {
    this.createCollectionForm.get('gatewayAmount').setValue(this.transactionDetailPaymentsDto.gatewayPayment.amount);

    if (this.transactionDetailPaymentsDto.gatewayPayment.amount > 0 && this.dialogData.trnsactionDto.refundAmt > 0)
      this.createCollectionForm.get('gatewayAmount').setValue(this.transactionDetailPaymentsDto.gatewayPayment.amount + this.dialogData.trnsactionDto.refundAmt);

    this.total_amt_cash = this.transactionDetailPaymentsDto.cashPayment.amount;
    this.total_amt_bank = this.transactionDetailPaymentsDto.bankPayment.amount
    this.total_amt_card = this.transactionDetailPaymentsDto.cardPayment.amount
    this.total_amt_coupon = this.transactionDetailPaymentsDto.couponPayment.amount
    this.total_amt_paytm = this.transactionDetailPaymentsDto.paytmPayment.amount
    this.total_amt_upi = this.transactionDetailPaymentsDto.upiPayment.amount
    this.total_amt_wallet = this.transactionDetailPaymentsDto.walletPayment.amount
    this.total_amt_swipe = this.transactionDetailPaymentsDto.swipePayment.amount
    this.total_amt_gateway = this.transactionDetailPaymentsDto.gatewayPayment.amount

    this.calcBalance()
  }

  onConfirmClick(event: any) {
    this.dialogRef.close({ data: this.transactionDetailPaymentsDto });
  }

  onRefundAmtChange(event) {
    let balanceValue = this.amountToPay - this.total_amt_byAllTypes;
    if (Number(event.target.value) <= Math.abs(balanceValue) && Number(event.target.value) > 0) {
      this.refundAmt = Number(event.target.value);
      this.balance = balanceValue + this.refundAmt;
    } else if (balanceValue < 0 && Number(event.target.value) < 0 || balanceValue < 0 && Number(event.target.value) > Math.abs(balanceValue)) {
      this.refundAmt = Math.abs(balanceValue);
      this.balance = 0;

      event.target.value = this.refundAmt;
    }

    this.transactionDtls.balance = this.balance;
    // this.transactionDetailPaymentsDto.refundAmt = this.refundAmt;
  }

  onWalletAmtChange(amount: number) {
    if (amount > this.useableWalletBalance && !this.isEditWallet) {
      this.toastService.showErrorToast(this.constant.walletBalanceToast)
      this.createCollectionForm.get('walletAmount').setValue(this.useableWalletBalance);
    }
  }

  //For Wallet
  getWalletHistory() {
    if (this.transactionDetailPaymentsDto.customerEmail) {
      this.walletTransaction = [];
      this.walletBalance = 0;
      // this.useableWalletBalance = 0;

      this.onViewWalletSubscription = this.shippingManagerService.getWalletTransaction(this.apiFactory.getWalletTransactionByEmail, this.transactionDetailPaymentsDto.customerEmail)
        .subscribe((data: any) => {
          console.log(data);
          if (data.length > 0) {
            this.walletTransaction = data;
            data.forEach(element => {
              if (element.status == "Credit") {
                this.walletBalance = Number((Number(this.walletBalance.toFixed(2)) + Number(element.credits.toFixed(2))).toFixed(2));
                element.balance = this.walletBalance;
              }
              else {
                this.walletBalance = Number((Number(this.walletBalance.toFixed(2)) - Number(element.credits.toFixed(2))).toFixed(2));
                element.balance = this.walletBalance;
              }
            })
            this.walletTransaction.reverse();
          } else {
            this.walletBalance = 0;
          }
          this.getWalletOffers();
        });
    }
  }

  getWalletOffers() {
    if (this.balance >= 0) {
      this.walletOfferRequestDto.locationCode = this.locationlocal;
      this.walletOfferRequestDto.email = this.transactionDetailPaymentsDto.customerEmail;
      this.walletOfferRequestDto.transactionPoint = this.transactionDetailPaymentsDto.transactionPoint;
      this.walletOfferRequestDto.applicableCustomer = 'General';
      this.walletOfferRequestDto.transactionType = 'Web Order';
      if (this.isEditWallet)
        this.walletOfferRequestDto.amount = this.transactionDetailPaymentsDto?.walletPayment.amount;
      else
        this.walletOfferRequestDto.amount = this.balance;

      this.offerList = [];

      this.getwalletOfferSubscription = this.shippingManagerService.getWalletOffers(this.apiFactory.getCheckedOutWalletOffers, this.walletOfferRequestDto)
        .subscribe((data: WalletOffers[]) => {
          this.offerList = data;
          this.offerList.forEach(element => {
            this.walletBalance += Number(element.walletAmount.toFixed(2));
          });
          this.walletBalance = Number(this.walletBalance.toFixed(2));
          if (this.transactionDetailPaymentsDto.walletPayment.refNo) {
            this.useableWalletBalance = Number(this.walletBalance.toFixed(2));
            this.transactionDetailPaymentsDto.walletPayment.appliedOfferList = this.offerList;
          }
          else
            this.useableWalletBalance = Number((this.walletBalance - this.total_amt_wallet).toFixed(2));
        })
    }
  }

  //Swipe
  sendPaymentRequestToEDC() {
    if (this.createCollectionForm.get('swipeAmount').value > 0) {
      let amtInPaisa: string = (this.createCollectionForm.get('swipeAmount').value * 100).toString();
      this.sendRequestEdcSubscription = this.shippingManagerService.searchEdcRequest(this.apiFactory.sendPaymentRequestToEDC, amtInPaisa, this.getSwipeTransNo(), this.locationlocal).subscribe((data: any) => {
        if (null != data) {
          console.log(data)
          this.swipeTransId = data.body.merchantTransactionId;
          this.paytmPaymentStatus = 'PAMENT INITIATED';
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("sendPaymentRequestToEDC", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.provideAllValueToast);
    }
  }

  checkPayTmPaymentStatus() {
    this.enableFetchSwipeBtn = false;
    if (this.swipeTransId) {
      this.checkPayTmPaymentStatusSubscription = this.shippingManagerService.checkPaytmStatus(this.apiFactory.checkPayTmPaymentStatus, this.swipeTransId, this.locationlocal).subscribe((data: any) => {
        if (null != data) {
          this.paytmPaymentStatus = 'TRANSACTION ' + data.body.resultInfo.resultStatus;
          if (data.body.resultInfo.resultStatus == 'FAIL' || data.body.resultInfo.resultStatus == 'SUCCESS')
            this.enableFetchSwipeBtn = false;
          else
            this.enableFetchSwipeBtn = true;

          this.savePaytmResponse(data.body);
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("checkPayTmPaymentStatus", error);
        });
    }
    else {
      this.toastService.showErrorToast(this.constant.sendRequestToast);
    }
  }

  savePaytmResponse(response: any) {
    let paytmResponse: PaytmResponse = new PaytmResponse();
    paytmResponse.acquirementId = response.acquirementId;
    paytmResponse.acquiringBank = response.acquiringBank;
    paytmResponse.aid = response.aid;
    paytmResponse.authCode = response.authCode;
    paytmResponse.bankMid = response.bankMid;
    paytmResponse.bankResponseCode = response.bankResponseCode;
    paytmResponse.bankResponseMessage = response.bankResponseMessage;
    paytmResponse.bankTid = response.bankTid;
    paytmResponse.cardScheme = response.cardScheme;
    paytmResponse.cardType = response.cardType;
    paytmResponse.issuerMaskCardNo = response.issuerMaskCardNo;
    paytmResponse.issuingBankName = response.issuingBankName;
    paytmResponse.merchantExtendedInfo = response.merchantExtendedInfo;
    paytmResponse.merchantReferenceNo = response.merchantReferenceNo;
    paytmResponse.merchantTransactionId = response.merchantTransactionId;
    paytmResponse.payMethod = response.payMethod;
    paytmResponse.paytmTid = response.paytmTid;
    paytmResponse.resultCode = response.resultInfo?.resultCode;
    paytmResponse.resultCodeId = response.resultInfo?.resultCodeId;
    paytmResponse.resultMsg = response.resultInfo?.resultMsg;
    paytmResponse.resultStatus = response.resultInfo?.resultStatus;
    paytmResponse.retrievalReferenceNo = response.retrievalReferenceNo;
    paytmResponse.transactionDateTime = response.transactionDateTime;
    paytmResponse.transactionAmount = response.transactionAmount;

    this.savePaytmResposeSubscription = this.shippingManagerService.savePaymentResponse(this.apiFactory.insertPaytmResponse, paytmResponse).subscribe((data: any) => {
      if (null != data) {
        this.paytmPaymentResponseCode = data;
      }
      else {
        this.toastService.showErrorToast(this.constant.serverSideErrorToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("checkPayTmPaymentStatus", error);
      });
  }

  sendEdcEmiterRequest(merchantTranId: string) {
    this.edcStatus = 'Payment Initiated';
    const eventSource = new EventSource(this.apiFactory.initiateNotification + merchantTranId);
    eventSource.addEventListener('message', (e) => {
      console.log(e.data);
      console.log(JSON.stringify(e.data));
      if (JSON.stringify(e.data).includes('Success :')) {
        console.log(JSON.stringify(e.data).split(":")[1]);
        let pids: string = JSON.stringify(e.data).split(":")[1].split("====")[0];
        console.log("Success : TxnStatus:SUCESS,RefNo:67====MOBPOS000120230912173655658");
        this.paytmPaymentResponseCode = Number(pids);
        this.edcStatus = 'Payment Successful';

      }
      else {
        console.log(JSON.stringify(e.data));
        this.edcStatus = 'Payment Failed';
      }
      eventSource.close();
    });
  }

  //Gateway
  sendGatewayPaymentLink() {
    this.getGatewaySetupSubscription = this.shippingManagerService.getGatewaySetup(this.apiFactory.getGatewayPaymentSetup, this.locationlocal, "CCAvenue").subscribe((data: GatewayPaymentSetup) => {
      if (data) {
        this.gatewayPaymentSetup = data;
        if (this.createCollectionForm.get('gatewayAmount').value > 0) {
          let ccAvenue: CCAvenueDataFormat = new CCAvenueDataFormat();
          ccAvenue.amount = this.createCollectionForm.get('gatewayAmount').value;
          ccAvenue.orderId = this.getSwipeTransNo();
          ccAvenue.merchantId = data.merchantId;
          ccAvenue.source = "mobitrix.net";
          var fiveMinutesLater = new Date();
          fiveMinutesLater.setMinutes(fiveMinutesLater.getMinutes() + 5);
          ccAvenue.validTill = moment(fiveMinutesLater).format("yyyy-MM-DDTHH:mm:ss");
          console.log(JSON.stringify(ccAvenue))
          this.sendRequestGatewaySubscription = this.shippingManagerService.sendGatewayPaymentRequest(this.apiFactory.sendGatewayPaymentRequest, JSON.stringify(ccAvenue)).subscribe((encdata: any) => {
            if (encdata) {
              console.log(encdata);
              // let url: string = "https://1bakeshop.integration.mobitrix.net/shortlink/" + encdata.encResp;

              // let url: string = "http://localhost:8082/shortlink/" + encdata.encResp;
              // let url: string = "https://payment.mobitrix.net/ccavenue?data=" + encdata.encResp + "&access=" + data.accessCode
              //   + "&orderid=" + ccAvenue.orderId + "&sourceLogo=https://1bakeshop.mobitrix.net/assets/images/mobitrix_logo.png";
              let url: string =
                this.appConfig.setting.paymentUrl +
                "ccavenue?data=" + encdata.encResp +
                "&access=" + data.accessCode +
                "&orderid=" + ccAvenue.orderId +
                "&tenantId=" + (this.sessionStorage.get('tenantId') || '') +
                "&sourceLogo=https://1bakeshop.com/assets/img/logo.webp";
              console.log(url);
              this.gatewayTransId = ccAvenue.orderId;
              this.onSendWhatsAppClick(url);
            }
            else {
              this.toastService.showErrorToast(this.constant.serverSideErrorToast);
            }
          },
            (error: HttpErrorResponse) => {
              this.insertErrorLog("sendGatewayPaymentLink", error);
            });
        }
        else {
          this.toastService.showErrorToast(this.constant.serverSideErrorToast);
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("sendGatewayPaymentLink", error);
      });
  }

  onSendWhatsAppClick(url: string) {
    let whatsAppMessageDto: WhatsAppMessageDto = new WhatsAppMessageDto();
    whatsAppMessageDto.companyId = this.companyCode;
    whatsAppMessageDto.mobileNo = [this.createCollectionForm.get('gatewayCustomerMobileNo').value];
    whatsAppMessageDto.templateId = "6641327";
    whatsAppMessageDto.parameters = [url];

    console.log(whatsAppMessageDto)

    this.onSendWhatsAppSubscription = this.shippingManagerService.sendWhatsAppMessage(this.apiFactory.sendWhatsAppMessageToRecipient, whatsAppMessageDto, this.uploadedFile).subscribe((data) => {
      if (data) {
        this.toastService.showSuccessToast(this.constant.linkSendToast);
        this.sendPGEmiterRequest(this.gatewayTransId);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onSendWhatsAppClick", error);
      });
  }

  sendPGEmiterRequest(merchantTranId: string) {
    this.pgStatus = 'Payment Initiated';
    const eventSource = new EventSource(this.apiFactory.initiateNotification + merchantTranId);
    eventSource.addEventListener('message', (e) => {
      console.log(e.data);
      console.log(JSON.stringify(e.data));
      if (JSON.stringify(e.data).includes('Success :')) {
        console.log(JSON.stringify(e.data).split(":")[1]);
        let pids: string = JSON.stringify(e.data).split(":")[1].split("========")[1];
        console.log(pids);
        this.gatewayPaymentResponseCode = Number(pids);
        this.pgStatus = 'Payment Successful';

      }
      else {
        console.log(JSON.stringify(e.data));
        this.pgStatus = 'Payment Failed';
      }
      eventSource.close();
    });
  }

  // checkGatewayPaymentStatus() {
  //   if (this.gatewayTransId) {
  //     this.checkGatewayPaymentStatusSubscription = this.collectService.sendGatewayPaymentRequest(this.apiFactory.checkCCAvenuePaymentStatus, this.gatewayTransId).subscribe((data: any) => {
  //       console.log(data);
  //       if (null != data) {
  //         this.saveGatewayResponse(data);
  //       }
  //       else {
  //         this.toastService.showErrorToast(this.constant.serverSideErrorToast);
  //       }
  //     },
  //       (error: HttpErrorResponse) => {
  //         this.insertErrorLog("checkGatewayPaymentStatus", error);
  //       });
  //   }
  //   else {
  //     this.toastService.showErrorToast('Please send request');
  //   }
  // }

  // saveGatewayResponse(response: any) {
  //   let gatewayResponse: CCAvenueResponse = new CCAvenueResponse();
  //   gatewayResponse.order_id = response.order_id;
  //   gatewayResponse.tracking_id = response.tracking_id;
  //   gatewayResponse.bank_ref_no = response.bank_ref_no;
  //   gatewayResponse.order_status = response.order_status;
  //   gatewayResponse.failure_message = response.failure_message;
  //   gatewayResponse.payment_mode = response.payment_mode;
  //   gatewayResponse.card_name = response.card_name;
  //   gatewayResponse.status_code = response.status_code;
  //   gatewayResponse.status_message = response.status_message;
  //   gatewayResponse.currency = response.currency;
  //   gatewayResponse.amount = response.amount;
  //   gatewayResponse.billing_name = response.billing_name;
  //   gatewayResponse.billing_address = response.billing_address;
  //   gatewayResponse.billing_city = response.billing_city;
  //   gatewayResponse.billing_state = response.billing_state;
  //   gatewayResponse.billing_zip = response.billing_zip;
  //   gatewayResponse.billing_country = response.billing_country;
  //   gatewayResponse.billing_tel = response.billing_tel;
  //   gatewayResponse.billing_email = response.billing_email;
  //   gatewayResponse.billing_notes = response.billing_notes;
  //   gatewayResponse.delivery_name = response.delivery_name;
  //   gatewayResponse.delivery_address = response.delivery_address;
  //   gatewayResponse.delivery_city = response.delivery_city;
  //   gatewayResponse.delivery_state = response.delivery_state;
  //   gatewayResponse.delivery_zip = response.delivery_zip;
  //   gatewayResponse.delivery_country = response.delivery_country;
  //   gatewayResponse.delivery_tel = response.delivery_tel;
  //   gatewayResponse.merchant_param1 = response.merchant_param1;
  //   gatewayResponse.merchant_param2 = response.merchant_param2;
  //   gatewayResponse.merchant_param3 = response.merchant_param3;
  //   gatewayResponse.merchant_param4 = response.merchant_param4;
  //   gatewayResponse.merchant_param5 = response.merchant_param5;
  //   gatewayResponse.vault = response.vault;
  //   gatewayResponse.offer_type = response.offer_type;
  //   gatewayResponse.offer_code = response.offer_code;
  //   gatewayResponse.discount_value = response.discount_value;
  //   gatewayResponse.retry = response.retry;
  //   gatewayResponse.response_code = response.response_code;
  //   gatewayResponse.mer_amount = response.mer_amount;
  //   gatewayResponse.sub_account_id = response.sub_account_id;
  //   gatewayResponse.eci_value = response.eci_value;
  //   gatewayResponse.si_created = response.si_created;
  //   gatewayResponse.si_status = response.si_status;
  //   gatewayResponse.si_ref_no = response.si_ref_no;
  //   gatewayResponse.si_sub_ref_no = response.si_sub_ref_no;
  //   gatewayResponse.si_mer_ref_no = response.si_mer_ref_no;
  //   gatewayResponse.si_error_desc = response.si_error_desc;
  //   gatewayResponse.bene_account = response.bene_account;
  //   gatewayResponse.bene_name = response.bene_name;
  //   gatewayResponse.bene_ifsc = response.bene_ifsc;
  //   gatewayResponse.bene_bank = response.bene_bank;
  //   gatewayResponse.bene_branch = response.bene_branch;
  //   gatewayResponse.inv_mer_reference_no = response.inv_mer_reference_no;
  //   gatewayResponse.trans_date = response.trans_date;
  //   gatewayResponse.trans_fee = response.trans_fee;
  //   gatewayResponse.service_tax = response.service_tax;
  //   gatewayResponse.bin_supported = response.bin_supported;
  //   gatewayResponse.bin_country = response.bin_country;
  //   gatewayResponse.customer_card_id = response.customer_card_id;

  //   this.savePaytmResposeSubscription = this.collectService.saveGatewayPaymentResponse(this.apiFactory.insertGatewayPaymentResponse, gatewayResponse).subscribe((data: any) => {
  //     if (null != data) {
  //       this.gatewayPaymentResponseCode = data.refNo;
  //     }
  //     else {
  //       this.toastService.showErrorToast(this.constant.serverSideErrorToast);
  //     }
  //   },
  //     (error: HttpErrorResponse) => {
  //       this.insertErrorLog("saveGatewayResponse", error);
  //     });
  // }

  getSwipeTransNo() {
    var myDate = moment(new Date()).format("YYYYMMDDHHmmssSSS");
    var moduleName = "MOB" + this.transactionDetailPaymentsDto.moduleName;
    var locId = this.locationlocal;
    let fornattedLoc = locId < 10 ? '000' + '' + locId : locId < 100 ? '00' + '' + locId : locId < 1000 ? '0' + '' + locId : locId;
    var randomstring = moduleName + fornattedLoc + myDate;
    console.log(randomstring)
    return randomstring;
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Payment Dialog";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }
  onCancelViewClick(data) {

  }
}
